import {
  LuCalendar,
  LuClock4,
  LuDatabase,
  LuFileText,
  LuUsers,
  LuWallet
} from "react-icons/lu";
import {
  Container,
  Description,
  FeatureCard,
  FeatureDescription,
  FeatureGrid,
  FeatureIconWrapper,
  FeatureTitle,
  Section,
  Tag,
  Title,
  TitleContainer
} from "./styles";

export default function Features() {
  const features = [
    {
      icon: <LuCalendar size={24} />,
      title: "Agendamento inteligente",
      description:
        "Gerencie sua agenda de forma descomplicada e eficiente, acessando seus compromissos de onde estiver e a qualquer momento. Organize consultas e retornos com facilidade e segurança, sem papelada e com todos os dados armazenados na nuvem."
    },
    {
      icon: <LuFileText size={24} />,
      title: "Prontuário eletrônico",
      description:
        "Transforme a gestão do seu consultório com o Prontuário Eletrônico completo, fácil de usar e 100% seguro em nuvem. Diga adeus à papelada e organize todos os dados dos seus pacientes de forma inteligente: histórico clínico, imagens, exames, receituários, tudo acessível em poucos cliques."
    },
    {
      icon: <LuWallet size={24} />,
      title: "Controle financeiro",
      description:
        "Acompanhe a saúde financeira da sua clínica em um painel completo: entradas, saídas, saldo e fluxo de caixa por categoria. Organize contas a pagar e a receber, registre lançamentos parcelados ou recorrentes e mantenha sua tabela de preços sempre à mão."
    },
    {
      icon: <LuUsers size={24} />,
      title: "Gestão de pacientes",
      description:
        "Tenha controle completo sobre o cadastro dos seus pacientes, com histórico de consultas, tratamentos, radiografias, e anotações organizadas de forma segura e acessível. Simplifique o gerenciamento dos dados, tudo em um só lugar."
    },
    {
      icon: <LuDatabase size={24} />,
      title: "Armazenamento seguro",
      description:
        "Dados criptografados na nuvem com backups automáticos e acesso controlado."
    },
    {
      icon: <LuClock4 size={24} />,
      title: "E mais em breve...",
      description:
        "Em breve, ainda mais funcionalidades para facilitar a gestão do seu consultório! Fique de olho nas próximas atualizações, como relatórios detalhados e muito mais."
    }
  ];

  return (
    <Section id="funcionalidades">
      <Container>
        <TitleContainer>
          <Tag>Funcionalidades</Tag>
          <Title>Tudo o que você precisa para sua clínica odontológica</Title>
          <Description>
            Nossa plataforma oferece todas as ferramentas necessárias para
            otimizar seus processos e melhorar a experiência dos seus pacientes.
          </Description>
        </TitleContainer>

        <FeatureGrid>
          {features.map((feature, index) => (
            <FeatureCard key={index} $animationDelay={`${index * 100}ms`}>
              <FeatureIconWrapper>{feature.icon}</FeatureIconWrapper>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
            </FeatureCard>
          ))}
        </FeatureGrid>
      </Container>
    </Section>
  );
}
